export default {
    getGoodStandingUnassigned: state => state.goodStandingUnassigned,
    getGoodStandingUnassignedSearched: state => state.goodStandingUnassignedSearched,

    getGoodStandingUnfinished: state => state.goodStandingUnfinished,
    getGoodStandingUnfinishedSearched: state => state.goodStandingUnfinishedSearched,
    getGoodStandingOthersUnfinished: state => state.goodStandingOthersUnfinished,
    getGoodStandingOthersUnfinishedSearched: state => state.goodStandingOthersUnfinishedSearched,

    getGoodStandingAssignedToYou: state => state.goodStandingAssignedToYou,
    getGoodStandingAssignedToYouSearched: state => state.goodStandingAssignedToYouSearched,
    getGoodStandingAssignedToOthers: state => state.goodStandingAssignedToOthers,
    getGoodStandingAssignedToOthersSearched: state => state.goodStandingAssignedToOthersSearched,

    getGoodStandingApproved: (state) => state.goodStandingApproved,
    getGoodStandingApprovedSearched: (state) => state.goodStandingApprovedSearched,
    getGoodStandingAllApproved: (state) => state.goodStandingAllApproved,
    getGoodStandingAllApprovedSearched: (state) => state.goodStandingAllApprovedSearched,

    getGoodStandingDeclined: (state) => state.goodStandingDeclined,
    getGoodStandingDeclinedSearched: (state) => state.goodStandingDeclinedSearched,
    getGoodStandingAllDeclined: (state) => state.goodStandingAllDeclined,
    getGoodStandingAllDeclinedSearched: (state) => state.goodStandingAllDeclinedSearched,

    getGoodStandingPendingPayment: (state) => state.goodStandingPendingPayment,
    getGoodStandingPendingPaymentSearched: (state) => state.goodStandingPendingPaymentSearched,
    getGoodStandingOthersPendingPayment: (state) => state.goodStandingOthersPendingPayment,
    getGoodStandingOthersPendingPaymentSearched: (state) => state.goodStandingOthersPendingPaymentSearched,

    getGoodStandingDeclinedPayment: (state) => state.goodStandingDeclinedPayment,
    getGoodStandingDeclinedPaymentSearched: (state) => state.goodStandingDeclinedPaymentSearched,
    getGoodStandingOthersDeclinedPayment: (state) => state.goodStandingOthersDeclinedPayment,
    getGoodStandingOthersDeclinedPaymentSearched: (state) => state.goodStandingOthersDeclinedPaymentSearched,

    getGoodStandingLicensed: (state) => state.goodStandingLicensed,
    getGoodStandingLicensedSearched: (state) => state.goodStandingLicensedSearched,
    getGoodStandingOthersLicensed: (state) => state.goodStandingOthersLicensed,
    getGoodStandingOthersLicensedSearched: (state) => state.goodStandingOthersLicensedSearched,

    getGoodStandingAllLicensed: (state) => state.goodStandingAllLicensed,
    getGoodStandingAllLicensedSearched: (state) => state.goodStandingAllLicensedSearched,

    getGoodStandingReApply: (state) => state.goodStandingReApply,
    getGoodStandingReApplySearched: (state) => state.goodStandingReApplySearched,
    getGoodStandingOthersReApply: (state) => state.goodStandingOthersReApply,
    getGoodStandingOthersReApplySearched: (state) => state.goodStandingOthersReApplySearched,

}